<template>
  <el-dialog
    :title="itemData ? '修改奖品' : '添加奖品'"
    :visible.sync="visible"
    width="720px"
    :before-close="toggle"
    destroy-on-close
    class="prize-dialog"
    z-index="20"
  >
  
    <el-form ref="prizeDialogForm" label-width="110px" :model="formData" label-position="right" :rules="formRules">
      <el-form-item label="奖品类型：" required prop="type">
        <el-radio-group v-model="formData.type" @change="handlePrizeTypeChange">
          <el-radio :label="10">智小美生活卡</el-radio>
          <el-radio :label="20">实物</el-radio>
          <!-- <el-radio :label="30">优惠券</el-radio>
          <el-radio :label="40">红包</el-radio> -->
        </el-radio-group>
      </el-form-item>

      <el-form-item label="奖品名称：" :prop="formData.type===10 ? 'cardTypeId' : 'name'">
        <!-- 生活卡为可搜索的 el-select -->
        <el-select
          v-if="formData.type===10"
          v-model="formData.cardTypeId"
          :multiple="false"
          filterable
          remote
          clearable
          placeholder="输入生活卡名称搜索"
          :remote-method="loadLifeCardData"
          :loading="lifeCardLoading"
          class="w-full"
        >
          <el-option
            v-for="item in lifeCardList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <!-- 其它为文本输入框 -->
        <el-input v-else v-model.trim="formData.name" placeholder="输入奖品名称" clearable maxlength="10" />
      </el-form-item>

      <el-form-item label="奖品说明：" prop="remark">
        <el-input
          type="text"
          v-model="formData.remark"
          rows="1"
          placeholder="输入奖品说明，示例：注册会员即可领取68元无门槛生活卡，购买农资永久享95折"
          maxlength="30"
          clearable
        />
      </el-form-item>

      <el-form-item label="奖品数量：" prop="num">
        <div class="vertical-radio-group">
          <el-radio-group v-model="formData.numType" @change="t => t===-1?formData.num=-1:formData.num=null">
            <el-radio :label="-1">不限数量</el-radio>
            <el-radio :label="0">
              总共
              <el-input v-if="formData.numType===-1" type="number" step="1" :min="1" max="99999" style="width: 130px;" :disabled="formData.numType===-1">
                <span class="text-gray" style="line-height: 40px;" slot="suffix">{{ formData.type === 10 ? '张' : '份' }}</span>
              </el-input>
              <el-input
                v-else
                v-model="formData.num"
                type="number"
                :min="1"
                style="width: 130px;"
                oninput="value = value.replace(/\./g, '');if(value.length > 5) value=value.slice(0, 5)"
              >
                <span class="text-gray" style="line-height: 40px;" slot="suffix">{{ formData.type === 10 ? '张' : '份' }}</span>
              </el-input>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item class="form-label-right" label="" prop="taskAuthPerson">
        <div class="flex items-center" slot="label">
          领取任务
          <el-tooltip effect="dark" content="可多选，用户需完成以下任务才可领取奖品" placement="top">
            <i class="el-icon-question" />
          </el-tooltip>：
        </div>
        <el-checkbox-group v-model="formData.taskAuthPerson">
          <el-checkbox :true-label="1" :false-label="0">农户身份认证</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="领取限制：" prop="limitType">
        <div class="vertical-radio-group">
          <el-radio-group v-model="formData.limitType" @change="handleLimitTypeChange">
            <el-radio :label="10" v-if="formData.type===20">不限制领取数量</el-radio>
            <el-radio :label="20">
              每个用户仅限领取
              <el-input
                v-if="formData.limitType===20"
                type="number"
                step="1"
                :min="1"
                :max="99"
                v-model="formData.limitNum"
                style="width: 80px;"
                oninput="value = value.replace(/\./g, '');if(value.length > 2) value=value.slice(0, 2)"
              >
                <span slot="suffix" style="line-height: 40px;" class="text-gray">{{ formData.type === 10 ? '张' : '份' }}</span>
              </el-input>
            </el-radio>
            <el-radio :label="30">
              每户家庭仅限领取
              <el-input
                v-if="formData.limitType===30"
                type="number"
                step="1"
                :min="1"
                :max="99"
                v-model="formData.limitNum"
                style="width: 80px;"
                oninput="value = value.replace(/\./g, '');if(value.length > 2) value=value.slice(0, 2)"
              >
                <span slot="suffix" style="line-height: 40px;" class="text-gray">{{ formData.type === 10 ? '张' : '份' }}</span>
              </el-input>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item label="领取时间：" prop="prizeAvailableDate">
        <el-date-picker
          v-model="formData.prizeAvailableDate"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="w-full"
          @change="handleDateChange"
        />
      </el-form-item>

      <el-form-item label="领取地址：" prop="address" v-if="formData.type===20 && show" class="remove-error-highlight">
        <ClaimAddress
          v-for="(item, index) in formData.address"
          :key="item._id"
          :index="index"
          :value="item"
          :removable="formData.address.length > 1"
          @remove="handleAddressRemove"
          @add="handleAddressAdd"
          @change="data => formData.address[index] = {...formData.address[index], ...data}"
        />
      </el-form-item>

      <el-form-item label="奖品介绍：" prop="prizeDisc" v-if="show">
        <Editor v-model="formData.prizeDisc" :limit-file-size="false" :default-value="formData.prizeDisc" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="flex justify-center">
      <el-button type="primary" @click="handleConfirm">确认{{ itemData ? '修改' : '添加' }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getActivityLifeCardApi } from '@/api'
import RegionMixin from '@/mixins/region'
import Editor from '@/components/Editor/index.vue'
import ClaimAddress from './ClaimAddress.vue'
export default {
  name: "PrizeDialog",
  mixins: [RegionMixin],
  components: { Editor, ClaimAddress },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    /** 编辑的奖品对象 */
    itemData: {
      type: Object,
      default: null
    },
    /** 活动设置的时间 */
    activityPeriod: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      visible: false,

      lifeCardLoading: false,
      lifeCardList: [],

      formData: {
        type: 10,
        cardTypeId: '', // 生活卡类型id
        name: '',
        remark: '',
        /** 奖品数量类型：-1不限数量，0其它 */
        numType: -1,
        num: -1,
        // prizeAmount: null,
        /** 任务：农户认证 0,1 ： 勾选为1 */
        taskAuthPerson: 0,
        limitType: 20,
        limitNum: null,
        /** 领取时间：只能在活动时间范围内 */
        prizeAvailableDate: '',
        startTime: '',
        endTime: '',
        prizeDisc: '',
        address: [{_id: Math.random()}]
      },

      formRules: {
        cardTypeId: [{required: true, message: '请输入奖品名称', trigger: 'blur'}],
        name: [{required: true, message: '请输入奖品名称', trigger: 'blur'}],
        num: [
          {
            required: true,
            message: '请选择奖品数量!',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (this.formData.numType !== -1) {
                if (!value) {
                  callback(new Error('请输入奖品数量'))
                } else if(value < 0) {
                  callback(new Error('奖品数量不能小于1'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        limitType: [
          {
            required: true,
            message: '请选领取限制',
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              if ((value === 20 || value === 30)) {
                if (!Number(this.formData.limitNum)) {
                  callback(new Error('请输入领取限制'))
                } else if (Number(this.formData.limitNum) < 1) {
                  callback(new Error('请输入1-99之间的整数'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        prizeAvailableDate: [
          {
            required: true,
            message: '请选领取时间',
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              let [startTime, endTime] = this.activityPeriod
              let [start, end] = value
              start = new Date(start)
              end = new Date(end)
              startTime = new Date(startTime)
              endTime = new Date(endTime)
              if (start < startTime) {
                callback('奖品领取开始时间不能小于活动开始时间')
              } else if (end > endTime) {
                callback('奖品领取结束时间不能大于活动结束时间')
              } else if (end < start) {
                callback('奖品领取结束时间不能小于奖品领取开始时间')
              } else {
                callback()
              }
            },
            trigger: 'blur'
          },
        ],
        address: [
          {
            required: true,
            message: '请输入领取地址!',
            trigger: 'change'
          },
          {
            validator: (rule, value, callback) => {
              let allFilled = value?.every(item => !!item.addressDetail?.length)
              if (this.formData.type === 20 && !allFilled) {
                callback(new Error('请输入领取地址'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        this.visible = newVal
        this.formData.prizeAvailableDate = this.activityPeriod ? this.activityPeriod : null
        if (newVal && this.itemData) { // 编辑
          let address = this.itemData.address ? this.itemData.address : []
          if (address.length) {
            address.forEach(item => item._id = Math.random())
          }

          let { type, cardTypeId, name, remark, num, taskAuthPerson, limitType, limitNum, startTime, endTime, prizeDisc} = this.itemData

          this.formData = {
            type,
            cardTypeId, // 生活卡类型id
            name,
            remark,
            /** 奖品数量类型：-1不限数量，0其它 */
            numType: num === -1 ? -1 : 0,
            num,
            /** 任务：农户认证 0,1 ： 勾选为1 */
            taskAuthPerson,
            limitType,
            limitNum,
            /** 领取时间：只能在活动时间范围内 */
            prizeAvailableDate: [startTime, endTime],
            startTime,
            endTime,
            prizeDisc,
            address,
          }

          this.lifeCardList = [{label: name, value: cardTypeId}]
        }

        if (!newVal) {
          this.$nextTick(() => {
            this.formData = {
              type: 10,
              cardTypeId: '', // 生活卡类型id
              name: '',
              remark: '',
              /** 奖品数量类型：-1不限数量，0其它 */
              numType: -1,
              num: -1,
              // prizeAmount: null,
              /** 任务：农户认证 0,1 ： 勾选为1 */
              taskAuthPerson: 0,
              limitType: 20,
              limitNum: null,
              /** 领取时间：只能在活动时间范围内 */
              prizeAvailableDate: '',
              startTime: '',
              endTime: '',
              prizeDisc: '',
              address: [{_id: Math.random()}]
            }
          })
        }
      },
    }
  },
  methods: {
    toggle() {
      this.visible = !this.visible
      this.$emit('update:show', this.visible)
      if (!this.visible) {
        this.$emit('close')
      }
    },

    handleDateChange(data) {
      this.formData.prizeAvailableDate = [data[0].split(':')[0] + ':00:00', data[1].split(':')[0] + ':00:00']
    },

    /** 切换奖品类型时，重置奖品名称、领取限制 */
    handlePrizeTypeChange(type) {
      this.formData.name = null
      if (type === 20) { // 实物
        this.formData.limitType = 10
      } else {
        this.formData.limitType = 20
      }
    },

    /** 领取限制变化时，重置限制数量，家庭限制时，自动勾选“农户身份认证” */
    handleLimitTypeChange(type) {
      if (!this.itemData) {
        this.formData.limitNum=null
      }
      if (type === 30) {
        this.formData.taskAuthPerson = 1
      }
    },

    handleAddressRemove(index) {
      this.formData.address = this.formData.address.filter((_, idx) => idx !== index)
    },

    handleAddressAdd() {
      this.formData.address.push({_id: Math.random()})
    },

    async loadLifeCardData(name) {
      try {
        let res = await getActivityLifeCardApi({name});

        if (res.code === 0) {
          this.lifeCardList = res.data.map(item => ({label: item.name, value: item.id}))
          return
        }
        this.lifeCardList = []
      } catch(err) {
        this.lifeCardList = []
      }
    },

    async handleConfirm() {
      try {
        await this.$refs.prizeDialogForm.validate()
        let data = {...this.formData}
        data.startTime = data.prizeAvailableDate[0]
        data.endTime = data.prizeAvailableDate[1]
        if (data.numType === -1) {
          data.num = -1
        }
        if (data.type === 10 && this.lifeCardList.length > 0) { // 生活卡，且有搜索列表
          // data.cardTypeId = this.formData.name
          data.name = this.lifeCardList.find(item => item.value === this.formData.cardTypeId)?.label || ''
        } else if (data.type === 10 && !this.lifeCardList.length) {}
        this.$emit('confirm', data)
        this.toggle()
      } catch(_err) {}
    },
  }
}
</script>

<style lang="less" scoped>
.form-label-right {
  /deep/ .el-form-item__label {
    display: flex;
    justify-content: flex-end;
  }
}

.vertical-radio-group {
  width: 260px;

  /deep/ .el-radio {
    margin: 8px 0;
  }
}

.prize-dialog {
  /deep/ .el-dialog__body {
    padding-bottom: 0;
  }
}

.remove-error-highlight {
  /deep/ .el-input__inner {
    border-color: #DCDFE6 !important;
  }
}
</style>